import { useCallback, useMemo, useState } from "react";

export const usePagination = <T extends any>(data: T[], volume: number = 10) => {
  const [rowsPerPage, setRowsPerPage] = useState(volume);

  const totalPages = useMemo(() => Math.ceil(data.length / rowsPerPage), [
    rowsPerPage,
    data.length
  ]);

  const [page, setPage] = useState(1);

  const slicedData = useMemo(
    () => data.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage),
    [data, rowsPerPage, page]
  );

  const nextPage = useCallback(() => {
    
    setPage((prevState: number) => {
      if (prevState < totalPages) {
        return prevState + 1;
      }

      return prevState;
    });
  }, [totalPages]);

  const prevPage = useCallback(() => {
    setPage((prevState: number) => {
      if (prevState > 1) {
        return prevState - 1;
      }

      return prevState;
    });
  }, []);

  return {
    data: slicedData,
    page,
    totalPages,
    rowsPerPage,
    setRowsPerPage,
    nextPage,
    prevPage,
    canPrevPage: page > 1,
    canNextPage: page < totalPages,
  };
};
